import api from '../utils/axiosConfig'

export interface TierStatusList {
  name: string
  min_points: number
  max_points: number
  monthly_bonus: number
  birthday_bonus: number
  gift_treats: number
  special_birthday_gift: boolean
}

export const getTierStatus = async (): Promise<TierStatusList[]> => {
  try {
    const response = await api.get('/user/status/list')
    return response.data.data.status_list as TierStatusList[]
  } catch (error: any) {
    console.error('Failed to fetch user status list:', error.response?.data)
    throw error
  }
}
